<script setup lang="ts">
  import { useStartupData } from '@/composables/useStartupData';
  import router from '@/router';
  import { useEnvironmentsStore } from '@/stores/environments';
  import { pickAllowedLocale, setLocale } from '@/utils/locale';
  import VLoadingView from '@/views/VLoadingView/VLoadingView.vue';

  const environmentsStore = useEnvironmentsStore();
  const { isLoading, isUnavailable, isEnvironmentsLoaded, loadEnvironments, recover } = useStartupData();
  const { locale } = useI18n();
  const hasPage = computed(() => router.currentRoute.value.matched.length > 0);

  const applyAllowedLocale = () => {
    const allowed = (environmentsStore.LANGUAGES ?? []).map((language) => language.code);
    const next = pickAllowedLocale(locale.value, allowed, environmentsStore.DEFAULT_LANGUAGE ?? '');
    if (next) {
      locale.value = next;
      setLocale(next);
    }
  };

  whenever(isEnvironmentsLoaded, applyAllowedLocale);

  onBeforeMount(() => {
    loadEnvironments();
  });
</script>

<template>
  <VToast />
  <VErrorLayout v-if="isUnavailable" @retry="recover" />
  <VLoadingView v-else-if="isLoading && !hasPage" />
  <RouterView v-else />
</template>
